// src/belediye/utils/poolHeader.js
// FAZ-25 ADIM-3 — havuz (pool) header bastırma kararı. SAF/test-edilebilir
// (localStorage/axios yan etkisi YOK); belediyeApi.resolveUnitSlugForHeader kullanır.
//
// Kural (kullanıcı kararı 2026-07-09): ui_profile=yonetici + AÇIK birim seçimi YOK →
// X-Unit-Slug GÖNDERME → backend permission-aware havuzu hesaplar
// (allowed_unit_ids_for_action). Aksi halde (operasyonel VEYA birim seçili) header
// gönderilir → bugünkü aktif-birim davranışı. ui_profile yetki vermez; yalnız mod seçer.

// activeUnit.js RESERVED + belediyeApi RESERVED_ROUTE_SLUGS ile hizalı tek kaynak.
export const RESERVED_UNIT_SLUGS = new Set([
  "birim-sec",
  "halk-masasi",
  "sistem",
  "saha",
  "baskanlik",
  "dashboard",
  "basvurular",
  "raporlar",
  "personel",
  "bildirimler",
]);

// Gerçek (seçili) bir birim slug'ı mı? (reserved/boş → hayır)
export const hasExplicitUnit = (slug) =>
  Boolean(slug) && !RESERVED_UNIT_SLUGS.has(slug);

// Havuz modunda header bastırılmalı mı?
// GÜVENLİK (denetim fix): permission_ui (uiOn) KAPALI iken ASLA bastırma →
// production'da (RBAC v2 pilotu kapalı) bugünkü aktif-birim davranışı korunur
// (frontend gerçekten DORMANT). Açıkken: yonetici + açık birim seçimi yok.
export const isPoolHeaderSuppressed = (uiOn, uiProfile, activeUnitSlug) =>
  uiOn === true && uiProfile === "yonetici" && !hasExplicitUnit(activeUnitSlug);
